import React from 'react'
import styled from 'styled-components'
import { rem, clearFix } from 'polished'
import media, { Grid } from '../../utils/style'
import { Flex, Box } from 'rebass'

import IconTickThin from '../../vectors/IconTickThin'
import { array, object, bool } from 'prop-types'

const DefaultIcon = styled(IconTickThin)`
  path {
    fill: ${(props) => props.theme.colors.green};
  }
`

const ListContainer = styled(({ isNarrow, ...rest }) => <Box {...rest} />)`
  margin-left: -30px;
  width: 100%;
`

const ListItem = styled(({ isNarrow, ...rest }) => <Box {...rest} />)`
  color: ${(props) => props.theme.colors.grey_op80};
  display: inline-block;
  vertical-align: top;
  line-height: 1.8;
  width: 100%;
  padding-left: 30px;
  ${media.MediumScreenUp`
  width: ${(props) => (props.isNarrow ? 100 : 50)}%;
  `};
  ${media.LargeScreenUp`
  width: 33.3333%;
  `};
  ${media.GiantScreenUp`
  width: 25%;
  `};
  ${clearFix()}
`

const ListIcon = styled(Grid)`
  float: left;
  height: 100%;
`

const ListText = styled(Box)`
  position: relative;
`

class ContentFeatureList extends React.PureComponent {
  render() {
    if (!this.props.list || this.props.list.length === 0) return null
    return (
      <Flex align pt={4} flexWrap="wrap">
        <ListContainer isNarrow={this.props.isNarrow}>
          {this.props.list.map((listItem, _index) => (
            <ListItem
              isNarrow={this.props.isNarrow}
              key={`cfl:${_index}${listItem}`}
            >
              <ListIcon
                pr={rem(this.props.spacing.r)}
                pb={[
                  rem(10),
                  rem(this.props.spacing.b / 2),
                  rem(this.props.spacing.b)
                ]}
                pt={rem(this.props.spacing.t)}
                pl={rem(this.props.spacing.l)}
              >
                {this.props.icon}
              </ListIcon>{' '}
              <ListText>{listItem}</ListText>
            </ListItem>
          ))}
        </ListContainer>
      </Flex>
    )
  }
}

ContentFeatureList.defaultProps = {
  list: [],
  icon: <DefaultIcon />,
  spacing: { t: 0, l: 0, b: 10, r: 15 }
}
ContentFeatureList.propTypes = {
  list: array,
  icon: object,
  spacing: object,
  isNarrow: bool
}
export default ContentFeatureList
